import { useAuth } from '@contexts/AuthContext';
import backgroundImage from '@assets/retry7.png';
import leoWordmark from '@assets/Leo_Wordmark__Transparent_light@4x.png';
import { Layout } from 'antd';

import { Navigate, Outlet, useLocation } from 'react-router';
const { Content } = Layout;

const AuthLayout = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const searchParams = new URLSearchParams(location.search);
  const normalizedPathname = location.pathname.replace(/\/+$/, '');

  const isCompletingProfile =
    searchParams.get('federated_signup_success') === '1' &&
    searchParams.get('complete_profile') === '1';

  const isCompletingSignupStep =
    normalizedPathname === '/auth/signup' && searchParams.get('step');

  const isFromDemo =
    normalizedPathname === '/auth/signup' && searchParams.get('from_demo') === '1';

  const shouldRedirectAuthenticated =
    isAuthenticated && !isCompletingProfile && !isCompletingSignupStep && !isFromDemo;

  return shouldRedirectAuthenticated ? (
    <Navigate to="/" replace />
  ) : (
    <Layout className="justify-center items-center flex bg-white">
      <Content className=" w-full flex h-screen flex-col md:flex-row md:overflow-hidden overflow-y-auto mx-auto">
        <div className="flex-1 flex-col md:flex-row flex justify-center items-center w-full">
          <div 
            className="absolute top-0 left-0 flex justify-center items-center p-5 z-10 invert md:invert-0"
            style={{
              mixBlendMode: location.pathname.includes('signup') ? 'normal' : 'difference',
            }}
          >
            <img src={leoWordmark} alt="Leo" className="h-8" />
          </div>
          {/* Left side - Visual Elements */}
          {location.pathname.includes('signup') &&
            <div className="flex-1 hidden md:flex relative h-full flex justify-center items-center">
              <div className="flex-1 relative h-full overflow-hidden">
                <img src={backgroundImage} className="w-full h-full object-cover " />
              </div>
            </div>}
          {/* Right side - Form */}
          <div className="h-full flex-1 p-5 mx-auto">
            <div className="max-w-[420px] mx-auto">
              <Outlet />
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
};

export default AuthLayout;
